import axios from 'axios';
import apiUrl from '../../api.config'

const TEST_API_URL = `${apiUrl}test`;

const TestService = {
    getBySchool(){
        return axios.get(TEST_API_URL + '/getBySchool', {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        });
    },
    getByTeacher(){
        return axios.get(TEST_API_URL + '/getByTeacher', {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        });
    },
    add(testData){
        return axios.post(TEST_API_URL + '/add', testData, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    update(testData){
        return axios.post(TEST_API_URL + '/update', testData, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    delete(testId){
        return axios.delete(TEST_API_URL + '/delete/' + testId, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    studentGetTest(){
        return axios.get(TEST_API_URL + '/studentGetTest', {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
}

export default TestService;